import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { apilo } from "@/lib/integrations-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/integracje/apilo";

export const Route = createFileRoute("/integracje/apilo")({
  head: () =>
    buildSeoMeta({
      title: "Wdrożenie Apilo — integracje Allegro, Amazon, kurierzy | SyncTech",
      description:
        "Konfiguracja Apilo dla sklepów wielokanałowych: Allegro, Amazon, eBay, Empik, Kaufland. Automatyzacja zamówień, etykiet kurierskich, fakturowania i ERP.",
      path: PATH,
    }),
  component: () => (
    <PlatformPage data={apilo} path={PATH} breadcrumbCategory="Integracje" />
  ),
});
